import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export default class FileSize extends React.Component {
    formatValue() {
        const props = {};
        if (!this.props.value) {
            props.file_size = <FormattedNumber value="0" />;
            return <FormattedMessage id={'file_size_bytes'} values={props} />;
        }

        const index = Math.floor(Math.log(this.props.value) / Math.log(1024));
        const formattedBytes = (this.props.value / Math.pow(1024, index)).toFixed(2);
        const id = [
            'file_size_bytes',
            'file_size_kb',
            'file_size_mb',
            'file_size_gb',
            'file_size_tb',
            'file_size_pb',
        ][index];

        props.file_size = <FormattedNumber value={formattedBytes} />;
        return <FormattedMessage id={id} values={props} />;
    }

    render() {
        return <span>{this.formatValue()}</span>;
    }
}

FileSize.propTypes = {
    value: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/FileSize.jsx